package fr.arcplex.network.template

data class CoherenceProgramTemplate(
    val contentType: String = "",
    val ratio: String = "",
    val revision: Int = 0,
    val registryVersion: Int = 0,
    val box: String = "",
    val platform: String = "",
    val rendererMinVersion: String = "",
    val minVersion: String = "",
    val gridWidth: Int = 0,
    val gridHeight: Int = 0,
    val gridColumns: Int = 0,
    val gridGutter: Int = 0,
    val safeArea: String = "",
    val regions: List<CoherenceRegion> = emptyList(),
    val attrs: Map<String, String> = emptyMap()
) {
    fun get(key: String): String? = attrs[key]
}

data class CoherenceRegion(
    val name: String = "",
    val col: Int = 0,
    val span: Int = 0,
    val height: String = "",
    val layers: List<CoherenceLayer> = emptyList(),
    val rails: List<CoherenceRailDef> = emptyList(),
    val slots: List<CoherenceSlot> = emptyList(),
    val attrs: Map<String, String> = emptyMap()
) {
    fun get(key: String): String? = attrs[key]
}

data class CoherenceLayer(
    val padding: String = "",
    val slots: List<CoherenceSlot> = emptyList(),
    val rows: List<CoherenceRow> = emptyList(),
    val columns: List<CoherenceColumn> = emptyList(),
    val rails: List<CoherenceRailDef> = emptyList(),
    val attrs: Map<String, String> = emptyMap()
) {
    fun get(key: String): String? = attrs[key]
}

data class CoherenceSlot(
    val name: String = "",
    val anchor: String = "",
    val maxItems: Int = 0,
    val maxLines: Int = 0,
    val attrs: Map<String, String> = emptyMap()
) {
    fun get(key: String): String? = attrs[key]
}

data class CoherenceRow(
    val gap: String = "",
    val align: String = "",
    val slots: List<CoherenceSlotRef> = emptyList(),
    val actions: List<CoherenceActionDef> = emptyList(),
    val attrs: Map<String, String> = emptyMap()
) {
    fun get(key: String): String? = attrs[key]
}

data class CoherenceColumn(
    val gap: String = "",
    val align: String = "",
    val slots: List<CoherenceSlotRef> = emptyList(),
    val rows: List<CoherenceRow> = emptyList(),
    val attrs: Map<String, String> = emptyMap()
) {
    fun get(key: String): String? = attrs[key]
}

data class CoherenceSlotRef(
    val name: String = "",
    val maxItems: Int = 0
) {
    fun get(key: String): String? = null
}

data class CoherenceActionDef(
    val name: String = "",
    val emphasis: String = "",
    val bgColor: String = "",
    val attrs: Map<String, String> = emptyMap()
) {
    fun get(key: String): String? = attrs[key]
}

data class CoherenceRailDef(
    val name: String = "",
    val title: String = "",
    val max: Int = 0,
    val attrs: Map<String, String> = emptyMap()
) {
    fun get(key: String): String? = attrs[key]
}
